import { type Locale } from '@ecom/i18n';
import { formatMillimesAsTnd } from '@ecom/i18n/currency';

const LOCALE_TAG: Readonly<Record<Locale, string>> = { fr: 'fr-TN', ar: 'ar-TN', en: 'en-TN' };

/** An amount in TND (the dashboard's figures are TND, not millimes) with the three decimals of the dinar. */
export function formatTnd(amount: number, locale: Locale): string {
  return formatMillimesAsTnd(Math.round(amount * 1000), locale);
}

export function formatCount(value: number, locale: Locale): string {
  return new Intl.NumberFormat(LOCALE_TAG[locale]).format(value);
}

/** Whole seconds between a server timestamp and now, never negative (a small clock difference must not print « in 2 seconds »). */
export function secondsSince(isoTimestamp: string, nowMs: number): number {
  const then = Date.parse(isoTimestamp);
  if (Number.isNaN(then)) return 0;
  return Math.max(0, Math.floor((nowMs - then) / 1000));
}

/** A `YYYY-MM-DD` period as a short date in the reader's language (the calendar day itself, whatever the browser's timezone). */
export function formatPeriod(period: string, bucket: 'day' | 'month', locale: Locale): string {
  const date = new Date(`${period}T00:00:00Z`);
  const options: Intl.DateTimeFormatOptions =
    bucket === 'day'
      ? { day: 'numeric', month: 'short', timeZone: 'UTC' }
      : { month: 'short', year: '2-digit', timeZone: 'UTC' };
  return new Intl.DateTimeFormat(LOCALE_TAG[locale], options).format(date);
}
